import { DataResponseTransformed, TabletReactQueryState } from "./tabletReactQuery";

    export interface ChannelType {  
        key: string;
        name: string;
        description: string;
    }

    export interface ChannelTypesModel extends DataResponseTransformed {
        rows: ChannelType[];
    }

    export interface ChannelTypesState extends TabletReactQueryState {
        filters?: any;
        columnVisibility?: any
    }

    export const channelTypesBuilder = {
        fromBackEnd: (channelType: any): ChannelType => ({
            key: channelType.key,
            name: channelType.name,
            description: channelType.description
        })
    }